import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PaginatedSearchResponse } from 'lib';
import { OrganizationSiteFilterDto } from '../interfaces/organization-site-filter-dto';
import { OrganizationSiteDto } from '../interfaces/organization-site-dto';

@Injectable({
    providedIn: 'root'
})
export class OrganizationSearchService {
    private http = inject(HttpClient);


    private baseUrl = environment.apiUrl + '/api/v1/organization';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchOrganizations(searchTerm: string, excludedOrganizations?: number[]): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        let params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('page', 0)
            .set('size', 5);

        if (excludedOrganizations && excludedOrganizations.length) {
            params = params.set(
                'excludedOrganizations',
                excludedOrganizations.join(',')
            );
        }
        return this.http.get(`${this.baseUrl}/search`, { headers, params });
    }

    searchAllOrganizations(searchFilter: OrganizationSiteFilterDto): Observable<PaginatedSearchResponse<OrganizationSiteDto>> {
        let params = new HttpParams()
            .set('page', searchFilter.page - 1)
            .set('size', searchFilter.size)
            .set('sort', this.getSortBy(searchFilter));
        if (searchFilter?.searchTerm) {
            params = params.append('searchTerm', searchFilter.searchTerm);
        }
        if (searchFilter?.belongsToEnterprise !== null && searchFilter?.belongsToEnterprise !== undefined) {
            params = params.append('belongsToEnterprise', searchFilter.belongsToEnterprise);
        }
        if (searchFilter?.status) {
            params = params.append('status', searchFilter.status);
        }
        if (searchFilter?.doNotEnable !== null && searchFilter?.doNotEnable !== undefined) {
            params = params.append('doNotEnable', searchFilter.doNotEnable);
        }
        if (searchFilter?.pod) {
            params = params.append('pod', searchFilter.pod);
        }
        if (searchFilter?.preconfigDateFilter) {
            params = params.append('preconfigDateFilter', searchFilter.preconfigDateFilter);
        }
        if (searchFilter?.enableDateFilter) {
            params = params.append('enableDateFilter', searchFilter.enableDateFilter);
        }
        if (searchFilter?.daysInOrganizationFilter) {
            params = params.append('daysInOrganizationFilter', searchFilter.daysInOrganizationFilter);
        }
        return this.http.get<PaginatedSearchResponse<OrganizationSiteDto>>(`${this.baseUrl}/search-all`, {
            params
        });
    }

    private getSortBy(searchFilter: OrganizationSiteFilterDto): string {
        return searchFilter.sortBy + ',' + searchFilter.sortOrder;
    }
}
